import { HelpPanel } from '@amzn/awsui-components-react-v3';
import React from 'react';
import '../styles/spotcp.css';

export function PhoenixInfo() {
  return (
    <HelpPanel
      header={<h2>Phoenix: Analytics</h2>}
    >
      <h3> How do you define accuracy? </h3>
      <div>
        The accuracy metric is a monthly comparison of the aggregated Daily CP
        (first published value within 24 hours of shipment, “first answer”) component
        values to an established benchmark. All components are compared against the
        benchmark resulting in a $ error for each intersection of marketplace, channel,
        and product line.  The absolute monetary error is aggregated and divided by the
        total absolute benchmark amount to produce an error percentage for each month.

        The metric serves as an error metric and doesn’t net out variances, holding
        accountability for the accuracy of each component down to the product line level.
        We will also be including the monetary per unit variance by component per country/channel
        to provide the impact of each component to the overall Net CP variance.
      </div>
    </HelpPanel>
  );
}



// WEBPACK FOOTER //
// ./src/utils/phoenix_info.jsx